import { render } from "./Chat.vue?vue&type=template&id=6b9f2524&scoped=true"
import script from "./Chat.vue?vue&type=script&lang=js"
export * from "./Chat.vue?vue&type=script&lang=js"

import "./Chat.vue?vue&type=style&index=0&id=6b9f2524&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6b9f2524"

export default script